export const sanitiseCmsString = (value: string | undefined | null) => {
  // The CMS has a bug that sets the value of empty string fields to a string of "undefined"
  // This helper function replaces that with an actual empty string
  if (value === "undefined" || value === undefined || value === null) {
    return "";
  }
  return value;
};

export const getCMSAccessories = (cmeSiloUiData: any) =>
  cmeSiloUiData?.features?.accessories?.options || {};

export const getCMSSiloFeatures = (cmeSiloUiData: any) => cmeSiloUiData?.features || {};

export const getCMSSiloFeaturesByOrder = (cmeSiloUiData: any, order: string[]) =>
  Object.fromEntries(
    order
      .map((key) => {
        const feature = cmeSiloUiData?.features?.[key];
        return feature ? [key, feature.title ?? key] : [];
      })
      .filter(Boolean),
  );
